import { HEADER_LOCALE_OVERRIDE } from "./HEADER_LOCALE_OVERRIDE";
export var COOKIE_LOCALE_OVERRIDE = HEADER_LOCALE_OVERRIDE;
